package com.essntl.features.itinerary.ui.edit_itinerary.components.messaging

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.essntl.uikit.components.checkbox.EsCheckBox
import com.essntl.uikit.components.checkbox.EsCheckBoxColors
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

enum class MessageType {
    SMS, WHATSAPP, EMAIL
}

@Composable
fun MessageTypeCheckBox(
    type: MessageType,
    enabled: Boolean,
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit
) {
    var isCheckBoxChecked by remember { mutableStateOf(checked) }

    val text = when (type) {
        MessageType.SMS -> {
            "SMS"
        }
        MessageType.WHATSAPP -> {
            "Whatsapp"
        }
        MessageType.EMAIL -> {
            "Email"
        }
    }

    EsCheckBox(
        colors = EsCheckBoxColors(
            backgroundCheckedBoxColor = MaterialTheme.esColorScheme.primary,
            backgroundUncheckedBoxColor = MaterialTheme.esColorScheme.secondaryHover,
            borderCheckedBoxColor = Color.Transparent,
            checkMarkColor = Color.White,
            disabledCheckedBoxColor = MaterialTheme.esColorScheme.secondaryDisabled,
            disabledCheckMarkColor = MaterialTheme.esColorScheme.iconDisabled,
        ),
        enabled = enabled,
        checked = isCheckBoxChecked,
        onCheckedChange = {
            isCheckBoxChecked = !isCheckBoxChecked
            onCheckedChange(isCheckBoxChecked)
        },
    )
    Spacer(Modifier.width(width = 1.spacing))
    Text(
        text = text,
        style = MaterialTheme.esTypography.p1Regular16,
        color = if (enabled) MaterialTheme.esColorScheme.textPrimary else MaterialTheme.esColorScheme.textDisabled,
    )
}